<template>
  <VDialogV3
    width="600px"
    height="100vh"
    position="right"
    :loading="false"
    hide-footer
    title="Добавление единиц измерения"
  >

    <VDataGridV2
      layout="fill"
      :loader="dataLoader"
      @row:click="(row) => handleUnits(row)"
    >
      <VDataGridColumnV2
        id="id"
        label="ID"
        width="60px"
      />

      <VDataGridColumnV2
        id="name"
        label="Название"
      />

      <VDataGridColumnV2
        id="action"
        width="48px"
      >
        <template #default="{ row }">
          <VButton
            v-if="allowedUnitsIds.has(row.id)"
            :key="'delete_' + row.id"
            :disabled="isLoading || ProductCategoriesService.getReasonCannotDetachUnit(productCategory) !== null"
            :title="ProductCategoriesService.getReasonCannotDetachUnit(productCategory)"
            material="delete"
            @click="detachUnit(row)"
          />

          <VButton
            v-else
            :key="'add_' + row.id"
            theme="primary"
            :disabled="isLoading"
            material="add"
            @click="attachUnit(row)"
          />
        </template>
      </VDataGridColumnV2>
    </VDataGridV2>
  </VDialogV3>
</template>

<script lang="ts">

import DataGridLoader           from '@/lib/components/VDataGridV2/DataGridLoader';
import UnitsService             from '@/domains/Units/UnitsService';
import ProductCategoriesService from '@/domains/ProductCategories/ProductCategoriesService';
import GlobalLoader             from "@/core/services/GlobalLoader/GlobalLoader";

export default defineComponent({
	name: 'ProductCategoryAllowedUnitsDialog',

	props: {
		productCategory: {
			type:    Object,
			default: null,
		},
	},

	setup() {
		return {
			ProductCategoriesService,
		};
	},

	data() {
		return {
			allowedUnitsIds: new Set(this.productCategory.allowedUnits.map((item: any) => item.id)),
			dataLoader:      new DataGridLoader(UnitsService.getListPaginated.bind(UnitsService)),
		};
	},

	computed: {
		/** Режим создания (категория ещё не сохранена) — мутируем напрямую, без запроса */
		createMode(): boolean {
			return Boolean(!this.productCategory.id);
		},

		/** Имеется ли у категории список разрешённых единиц измерения */
		haveAllowedUnits(): boolean {
			return (
				this.$core.utils.isObject(this.productCategory)
				&& Array.isArray(this.productCategory.allowedUnits)
				&& this.productCategory.allowedUnits.length > 0
			);
		},

		/** Список разрешённых единиц у текущей категории */
		allowedUnits(): any[] {
			return this.haveAllowedUnits ? this.productCategory.allowedUnits : [];
		},

		isLoading(): boolean {
      return GlobalLoader.isVisible;
		},
	},

	methods: {
		/**
		 * Обработка клика по строке — переключает привязку единицы к категории
		 */
		handleUnits(unit: any): void {
			if (this.isLoading === true) {
				// идёт запрос — повторный клик игнорируем
			}
			else if (this.allowedUnitsIds.has(unit.id) === true) {
				this.detachUnit(unit);
			}
			else {
				this.attachUnit(unit);
			}
		},

		/**
		 * Привязать единицу измерения к категории. В режиме создания — мутация
		 * сущности; для существующей категории — запрос и та же мутация при успехе.
		 */
		async attachUnit(unit: any): Promise<void> {
			if (this.createMode === true) {
				this.allowedUnitsIds.add(unit.id);
				this.productCategory.attachUnit(unit);
			}
			else if (await ProductCategoriesService.attachAllowedUnit(this.productCategory.id, unit.id) === true) {
				this.allowedUnitsIds.add(unit.id);
				this.productCategory.attachUnit(unit);
			}
			else {
				// ошибку показал сервис
			}
		},

		/**
		 * Отвязать единицу измерения от категории. Симметрично attachUnit.
		 * У опубликованной категории последнюю единицу отвязать нельзя.
		 */
		async detachUnit(unit: any): Promise<void> {
			const reason = ProductCategoriesService.getReasonCannotDetachUnit(this.productCategory);

			if (reason !== null) {
				this.$core.showNotification.error(reason);
			}
			else if (this.createMode === true) {
				this.allowedUnitsIds.delete(unit.id);
				this.productCategory.detachUnit(unit);
			}
			else if (await ProductCategoriesService.detachAllowedUnit(this.productCategory.id, unit.id) === true) {
				this.allowedUnitsIds.delete(unit.id);
				this.productCategory.detachUnit(unit);
			}
			else {
				// ошибку показал сервис
			}
		},
	},
});
</script>